import { render, staticRenderFns } from "./ManageCategories.vue?vue&type=template&id=000de846&scoped=true&"
import script from "./ManageCategories.vue?vue&type=script&lang=js&"
export * from "./ManageCategories.vue?vue&type=script&lang=js&"
import style0 from "./ManageCategories.vue?vue&type=style&index=0&id=000de846&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000de846",
  null
  
)

export default component.exports